import { consola } from 'consola'
export const useScrollTo = () => {
  /**
   * Scrolls smoothly to the target element.
   * @param {string} selector - CSS selector of the target element to scroll to.
   */
  const scrollTo = (selector: string): void => {
    const targetElement = document.querySelector(selector.startsWith("#") ? selector : `#${selector}`);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    } else {
      consola.warn("Element not found:", selector);
    }
  };


  return { scrollTo };
};
